import { render, staticRenderFns } from "./ParametricLimit.vue?vue&type=template&id=678daf65"
import script from "./ParametricLimit.vue?vue&type=script&lang=js"
export * from "./ParametricLimit.vue?vue&type=script&lang=js"
import style0 from "./ParametricLimit.vue?vue&type=style&index=0&id=678daf65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports